<div class="chart-wrapper">
    <canvas baseChart
        [datasets]="bubbleChartData"
        [options]="bubbleChartOptions"
        [legend]="bubbleChartLegend"
        [type]="bubbleChartType">
    </canvas>
</div>